const BaseUrl = 'https://chameli-backend.cdgi.edu.in/api';
// const BaseUrl = 'http://122.160.154.127:8080/api';
export default BaseUrl